<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Services</span>
        <h1>Manage IOSC services.</h1>
        <p>Update service title, description, icon key, CTA and status.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div *ngIf="successMessage" class="alert success" style="margin-bottom:16px">
            {{ successMessage }}
        </div>

        <div *ngIf="errorMessage" class="alert error" style="margin-bottom:16px">
            {{ errorMessage }}
        </div>

        <div class="contact-grid">

            <main class="quote-panel">
                <span class="section-kicker">Service Form</span>
                <h2 style="font-size:32px;margin-top:8px">
                    {{ model.id === 0 ? 'New Service' : 'Edit Service' }}
                </h2>

                <div class="form-grid">

                    <div class="field">
                        <label>Title</label>
                        <input [(ngModel)]="model.title" name="serviceTitle" placeholder="WAREHOUSING">
                    </div>

                    <div class="field">
                        <label>Icon Key</label>
                        <select [(ngModel)]="model.iconKey" name="serviceIconKey">
                            <option value="">Select icon</option>
                            <option *ngFor="let key of iconKeys" [value]="key">
                                {{ key }}
                            </option>
                        </select>
                    </div>

                    <div class="field">
                        <label>CTA Text</label>
                        <input [(ngModel)]="model.ctaText" name="serviceCtaText" placeholder="Request service →">
                    </div>

                    <div class="field">
                        <label>CTA URL</label>
                        <input [(ngModel)]="model.ctaUrl" name="serviceCtaUrl" placeholder="/contact">
                    </div>

                    <div class="field">
                        <label>Sort</label>
                        <input type="number" [(ngModel)]="model.sort" name="serviceSort">
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="model.status" name="serviceStatus">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full">
                        <label>Description</label>
                        <textarea [(ngModel)]="model.description" name="serviceDescription"></textarea>
                    </div>

                    <div class="field full" style="display:flex;gap:10px;flex-direction:row">
                        <button class="btn btn-primary" type="button" (click)="saveService()" [disabled]="saving">
                            {{ saving ? 'Saving...' : 'Save Service' }}
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="newService()">
                            Clear
                        </button>
                    </div>

                </div>
            </main>

            <aside>
                <span class="section-kicker">Service List</span>
                <h2 style="font-size:34px">Current services.</h2>

                <div *ngIf="loading">Loading services...</div>

                <div class="office-card premium-office" *ngFor="let s of services">
                    <h3>{{ s.title }}</h3>

                    <p>{{ s.description }}</p>

                    <span>
                        {{ s.iconKey }} /
                        {{ s.status ? 'Active' : 'Hidden' }} /
                        Sort {{ s.sort }}
                    </span>

                    <div style="display:flex;gap:8px;margin-top:14px">
                        <button class="btn btn-ghost" type="button" (click)="editService(s)">
                            Edit
                        </button>

                        <button class="btn btn-dark" type="button" (click)="deleteService(s.id)">
                            Delete
                        </button>
                    </div>
                </div>

                <div *ngIf="!loading && services.length === 0" style="padding:20px 0">
                    No services found.
                </div>
            </aside>

        </div>

    </div>
</section>